export enum DenialReason {
  MEDICAL_NECESSITY = "Not medically necessary",
  NOT_A_COVERED_BENEFIT = "Not a covered benefit",
  FORMULARY = "Not covered on formulary",
  SITE_OF_CARE = "Not covered at site of care",
  NETWORK = "Doctor not in network",
  STEP_THERAPY_REQUIRED = "Requires step therapy",
  FORCED_MEDICATION_SWITCH = "Forced switch by plan",
  PA_REQUIREMENTS_NOT_MET = "PA requirements not met",
  ANTICIPATED_FORMULARY_CHANGE = "Anticipated Formulary Change",
}
